const PRODUCT = 'PRODUCT'
const ACCOUNT = 'ACCOUNT'
const ACCOUNT_TO_ACCOUNT = 'ACCOUNT_TO_ACCOUNT'

export default {
    PRODUCT,
    ACCOUNT,
    ACCOUNT_TO_ACCOUNT,
    list: [
        {
            name: 'Produto',
            value: PRODUCT
        },
        {
            name: 'Conta',
            value: ACCOUNT
        },
        {
            name: 'Conta para conta',
            value: ACCOUNT_TO_ACCOUNT
        }
    ]
}
